'use strict';

angular.module('shiftTraderApp')
    .directive('saDaysOffManagementList', ['TimeService', 'DaysOffManagementModalService',
    function (TimeService, DaysOffManagementModalService) {
      return {
        templateUrl: 'views/daysOff/saDaysOffManagementList.html',
        restrict: 'A',
        scope: {
          departments: '='
        },
        controllerAs: 'listCtrl',
        bindToController: true,
        controller: ['$scope', 'DaysOffManagementModalService', 'DayOffLimitStore', 'Session', 'TimeService', function($scope, DaysOffManagementModalService, DayOffLimitStore, Session, TimeService) {
          var vm = this;

          vm.state = {
            currentDate: DaysOffManagementModalService.getCurrentDate()
          };

          vm.cssClasses = {};

          function setOrgAdjustedCurrentDate() {
            vm.state.orgAdjustedCurrentDate = TimeService.getBeginningOfDayFromDateWithOrgSetting(vm.state.currentDate);
          }

          setOrgAdjustedCurrentDate();


          function flushLimitCache() {
            vm.cachedLimit = null;
            vm.cachedLimitRecord = null;
          }

          flushLimitCache();

          function updateLimitCache() {
            DayOffLimitStore.getLimitForDate(vm.state.currentDate)
              .then(function(limitRecord) {
                if (limitRecord) {
                  vm.cachedLimit = limitRecord.limit;
                  vm.cachedLimitRecord = limitRecord;
                  updateList();
                }
              }, function() {
                console.log('failed to retrieve limit');
              })
          }

          function setDepartmentNamesForList() {

            if (vm.daysOffList) {
              _.each(vm.daysOffList, function(listItem) {
                var deptNames = [];

                if (listItem.type === 'dayOff' && vm.departments && vm.departments.length) {
                  var hasDeptMetadata = listItem.dayOff.user.metadata && listItem.dayOff.user.metadata.department_ids_by_org &&
                    listItem.dayOff.user.metadata.department_ids_by_org.data && listItem.dayOff.user.metadata.department_ids_by_org.data[listItem.dayOff.organization_id]
                    && listItem.dayOff.user.metadata.department_ids_by_org.data[listItem.dayOff.organization_id].length > 0;

                  _.each(vm.departments, function(dept) {
                    if (!_.isNull(dept.id) &&
                      hasDeptMetadata &&
                      _.contains(listItem.dayOff.user.metadata.department_ids_by_org.data[listItem.dayOff.organization_id], dept.id)) {
                      deptNames.push(dept.name);
                    }
                  });
                }

                if (deptNames.length > 0) {
                  listItem._department_names = deptNames;
                }
              });
            }
          }

          function updateList() {
            // TODO: This should look up what the limit actually is!

            function genEmptyListObject() {
              return {
                type: 'empty',
                id: -2,
                date: vm.state.currentDate
              };
            }

            function genLimitListObject(numPending, numApproved) {
              var limitIsSet = !_.isNull(vm.cachedLimit) && !_.isUndefined(vm.cachedLimit);
              return {
                id: -1,
                type: 'limit',
                date: vm.state.currentDate,
                limit: vm.cachedLimit,
                limitIsSet: limitIsSet,
                numPending: numPending,
                numApproved: numApproved,
                numCounted: numPending + numApproved,
                atLimit: limitIsSet && ((numPending + numApproved) === vm.cachedLimit),
                underLimit: limitIsSet && ((numPending + numApproved) < vm.cachedLimit),
                overLimit: limitIsSet && ((numPending + numApproved) > vm.cachedLimit)
              };
            }

            DaysOffManagementModalService.getDaysOffIntersectingCurrentDate()
              .then(function(daysOff) {
                // filter the list, making sure that we filter out requests that are just barely into today due to
                //   the WorkDayStartHour
                var workDayStartHour = Session.getWorkDayStartHour();
                var dtTwix = moment(vm.state.currentDate).twix(moment(vm.state.currentDate).add(1, 'days'));
                var adjustedDtTwix = moment(vm.state.orgAdjustedCurrentDate).twix(moment(vm.state.orgAdjustedCurrentDate).add(1, 'days'));

                vm.daysOffObjects = _.sortBy(_.map(_.where(daysOff, function(dayOff) {
                  var isMultiDayRequest = dayOff.range_twix.start.dayOfYear() !== dayOff.range_twix.end.dayOfYear();
                  var dtIntersection = dtTwix.overlaps(dayOff.range_twix) ? Math.abs(dayOff.range_twix.intersection(dtTwix).length('minutes')) : 0;

                  // don't show dayOff's that have been removed by a manager
                  // if this is a single day request OR if the request overlaps the day by MORE than dayStartHour hrs, then show it.
                  return !dayOff.$wasCancelledOrRemoved() && ((!isMultiDayRequest && dtIntersection > 0) || (isMultiDayRequest && dtIntersection > ( workDayStartHour * 60)));
                  }), function(dayOff) {
                  var selectedDayOff = DaysOffManagementModalService.getSelectedDayOff();

                  // we know that range_twix overlaps the dtTwix now.
                  // check endpoints to see if the selected day consumes this day off

                  var dayOffConsumesOrgAdjustedDay = (dayOff.range_twix.start.isBefore(adjustedDtTwix.start) || dayOff.range_twix.start.isSame(adjustedDtTwix.start, 'minute'))
                    && (dayOff.range_twix.end.isAfter(adjustedDtTwix.end) || dayOff.range_twix.end.isSame(adjustedDtTwix.end, 'minute'));

                  var isMultiDay = (dayOff.range_twix.start.isBefore(adjustedDtTwix.start) &&
                                    dayOff.range_twix.end.isAfter(adjustedDtTwix.start)) ||
                                    (dayOff.range_twix.end.isAfter(adjustedDtTwix.end) &&
                                    dayOff.range_twix.start.isBefore(adjustedDtTwix.end));

                  dayOff._cssClasses = {
                    selected: selectedDayOff && selectedDayOff.id === dayOff.id,
                    'all-day': dayOffConsumesOrgAdjustedDay,
                    'partial-day': !dayOffConsumesOrgAdjustedDay,
                    'multi-day': isMultiDay,
                    pending: dayOff.$isPending() && dayOff.active,
                    approved: dayOff.$isApproved() && dayOff.active,
                    disapproved: dayOff.$isDisapproved() && !dayOff.active,
                    cancelled: dayOff.$isCancelled(),
                    removed: dayOff.$wasRemoved()
                  };

                return dayOff;
                }), '_created_at_unix');

                var pendingApprovedRequestNum = 0;
                var numPendingRequests = 0;
                var numApprovedRequests = 0;
                var addedLimitObject = false; // tracking whether or not we already added the limit object to list

                var list = [];

                if (vm.daysOffObjects.length === 0) {
                  list.push(genEmptyListObject());
                } else {
                  numPendingRequests = _.reduce(vm.daysOffObjects, function(sum, dayOff) {
                    return dayOff.$isPending() ? sum + 1 : sum;
                  }, 0);

                  numApprovedRequests = _.reduce(vm.daysOffObjects, function(sum, dayOff) {
                    return dayOff.$isApproved() ? sum + 1 : sum;
                  }, 0);
                }

                if (!_.isNull(vm.cachedLimit) && vm.cachedLimit === 0) {
                  list.push(genLimitListObject(numPendingRequests, numApprovedRequests));
                  addedLimitObject = true;
                }

                _.each(vm.daysOffObjects, function(dayOff, idx) {
                  var showNumber = (dayOff.$isApproved() || dayOff.$isPending());

                  if (showNumber) {
                    pendingApprovedRequestNum += 1;
                  }

                  list.push({
                    type: 'dayOff',
                    id: dayOff.id,
                    dayOff: dayOff,
                    showPosition: showNumber,
                    listPosition: showNumber ? pendingApprovedRequestNum : '',
                    absoluteListPosition: idx + 1
                  });

                  if (!_.isNull(vm.cachedLimit) && showNumber && pendingApprovedRequestNum === vm.cachedLimit && !addedLimitObject) {
                    addedLimitObject = true;
                    list.push(genLimitListObject(numPendingRequests, numApprovedRequests));
                  }
                });

                // last term in expression is to make sure we don't have 2 limit objects
                if (!_.isNull(vm.cachedLimit) && (pendingApprovedRequestNum > 0 && pendingApprovedRequestNum < vm.cachedLimit && !addedLimitObject)) {
                  list.push(genLimitListObject(numPendingRequests, numApprovedRequests));
                }

                vm.daysOffList = list;

                if (!DaysOffManagementModalService.getSelectedDayOff()) {
                  var pendingDayOff = _.find(vm.daysOffObjects, function(dayOff) {
                    return dayOff.$isPending()
                  });

                  if (pendingDayOff) {
                    DaysOffManagementModalService.setSelectedDayOffId(pendingDayOff.id);
                  }
                }

                setDepartmentNamesForList();
              }, function() {
                console.log('fetch failed');
              });

          }

          vm.selectDayOff = function(dayOff) {
            DaysOffManagementModalService.setSelectedDayOffId(dayOff.id);
          };


          updateList();
          updateLimitCache();

          _([DaysOffManagementModalService.dateChangeEventName,
              DaysOffManagementModalService.dataChangeEventName,
              DaysOffManagementModalService.selectedDayOffChangedEventName]).each(function(eventName) {
            $scope.$on(eventName, function(e) {
              console.log(e.name, e.data && e.data.format());

              // check and see if the currentDate is different now than before..
              // if it is different then clear the limitCache
              // if it is NOT then just updateList
              var newDate = DaysOffManagementModalService.getCurrentDate();
              if (!newDate.isSame(vm.state.currentDate, 'second')) {
                vm.state.currentDate = newDate;
                setOrgAdjustedCurrentDate();
                flushLimitCache();
                updateLimitCache();
              }

              updateList();

            });
          });

          $scope.$on(DaysOffManagementModalService.toggleDepartmentModeEventName, function(event) {
            vm.departmentShowState = DaysOffManagementModalService.getDepartmentMode();
            vm.cssClasses = {
              'show-departments': vm.departmentShowState
            };


            setDepartmentNamesForList();
          });

        }]
      };
    }]);
